import {takeLatest, put, all} from 'redux-saga/effects';
import * as fromApi from '../../../lib/api/musiconline.api';

function* watchPostArtisteLapp(action) {
	try {
		const result = yield fromApi.artisteLappPost(action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'POST_ARTISTELAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetArtisteLapps(action) {
	try {
		const result = yield fromApi.artisteLappsGet(action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_ARTISTELAPPS_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchGetArtisteLapp(action) {
	try {
		const result = yield fromApi.artisteLappGet(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'GET_ARTISTELAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchPutArtisteLapp(action) {
	try {
		const result = yield fromApi.artisteLappPut(action.payload, action.token, action.data).then((data) => {
			return data;
		});
		yield put({type: 'PUT_ARTISTELAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}
function* watchDelArtisteLapp(action) {
	try {
		const result = yield fromApi.artisteLappDel(action.payload, action.token).then((data) => {
			return data;
		});
		yield put({type: 'DEL_ARTISTELAPP_RETURN', payload: result});
	} catch (error) {
		yield put({
			type: 'ERROR',
			error: true,
			payload: error
		});
	}
}

function* artisteslapp() {
	yield takeLatest('POST_ARTISTELAPP_SAGAS', watchPostArtisteLapp);
	yield takeLatest('GET_ARTISTELAPPS_SAGAS', watchGetArtisteLapps);
	yield takeLatest('GET_ARTISTELAPP_SAGAS', watchGetArtisteLapp);
	yield takeLatest('PUT_ARTISTELAPP_SAGAS', watchPutArtisteLapp);
	yield takeLatest('DEL_ARTISTELAPP_SAGAS', watchDelArtisteLapp);
}

export default function* rootSaga() {
	yield all([artisteslapp()]);
}
